<div class="route-fullscreen" [class.no-scroll]="isSocialShareVisible">
    <div class="modal-body album-videos">
        <div *ngIf="!showAd">
            <div class="album-video-title-box">
                <div class="album-video-title"> {{selectedVideo?.stage}} </div>
                <ng-container *ngIf="!router.url.includes('/preview')">
                    <div class="report-btn album-video-title"
                        (click)="reportFileData(selectedVideo, 'playerVideo')" matTooltipPosition="below"
                        matTooltip="Report Abuse"
                        [ngClass]="{'slick-disabled':router.url.includes('/preview')}">
                        <i class="fa fa-flag"></i>
                    </div>
                </ng-container>
                <div class="close-btn album-video-title" (click)="close()">
                    <app-svg [icon]="'live-stream-close-icon-white'"></app-svg>
                </div>
            </div>
            <div class="video-player-container">
              <div class="video-wrapper">
                <div class="video-container">
                  <video
                    #videoElement
                    id="stormcloud-video"
                    autoplay
                    controls
                    crossorigin="anonymous"
                    (loadedmetadata)="onVideoLoaded($event)"
                    (error)="onVideoError($event)"
                    (timeupdate)="getCurrentTime($event)"
                    class="video-element video-album"
                  >
                    <source [src]="videoURL" type="application/x-mpegURL" *ngIf="videoURL">
                    Your browser does not support the video tag.
                  </video>
                  
                  <!-- Debug Info -->
                  <div *ngIf="!videoElement" class="video-debug">
                    Video element not found in DOM
                  </div>
                  <div *ngIf="!videoURL" class="video-debug">
                    No video source available
                  </div>
                </div>
              </div>
            </div>

    </div>

    <div class="video-actions" [ngClass]="isCommentsEnable || tag_category == 'recorded-video' ? 'actions-padding' :'shareVideo-padding'">
      <div class="left">
        <span class="video-title" *ngIf="isCommentsEnable || tag_category == 'recorded-video'">Comment Section</span>
      </div>
      <div class="right">
        <!-- Like button -->
        <div class="action-wrapper" *ngIf="tag_category !== 'recorded-video'">
          <button class="action-btn" (click)="userInfo && userInfo.access_token ? likeVideo(): requireLogin()">
            <i class="fa fa-thumbs-up"></i>
          </button>
          <span class="action-count">{{selectedVideo?.user_likes |  abbreviatedNumber}}</span>
        </div>
      
        <!-- Share button -->
        <div class="action-wrapper">
          <button class="action-btn" (click)="shareVideo()">
            <i class="fa fa-share-alt"></i>
          </button>
          <span class="action-count">share</span>
          <span *ngIf="isSocialShareVisible" class="social-share">
            <app-social-share-link
              [slugName]="router.url"
              [sharedFrom]="'album-video'"
              [settingsData]="settingsData ? settingsData :''"
              (closeShareEvent)="closeSocialSharePopup($event)">
            </app-social-share-link>
          </span>
        </div>
      
        <!-- Comment button -->
        <div class="action-wrapper" *ngIf="isCommentsEnable || tag_category == 'recorded-video'">
          <button class="action-btn" >
            <i class="fa fa-comment"></i>
          </button>
          <span class="action-count">{{ comments?.length || 0 }}</span>
        </div>
      
        <!-- View/copy link button -->
        <div class="action-wrapper" *ngIf="tag_category !== 'recorded-video'">
          <button class="action-btn">
            <i class="fa fa-eye"></i>
          </button>
          <span class="action-count">{{selectedVideo?.user_views}}</span>
        </div>
      </div>
      
    </div>

    <div class="route-comments-section" *ngIf="tag_category == 'recorded-video' || isCommentsEnable">
      <div class="comments-header-row">
        <h3 class="comments-header">{{ comments?.length || 0 }} Comments</h3>
      </div>
    
      <!-- Add Comment -->
      <div class="comment-input-box">
        <div class="roundIcon text-center mr-5" *ngIf="userInfo?.profile_pic; else userName">
          <img class="roundUserImage" src="{{userInfo?.profile_pic}}">
        </div>
        <ng-template #userName>
          <div class="comment-avatar">
            <span class="avatar-text">
              {{ getUserInitials() }}
            </span>
          </div>
        </ng-template>
    
        <div class="comment-input-area">
          <div class="input-wrapper">
            <textarea
              [(ngModel)]="newComment"
              placeholder="Add a comment..."
              rows="1"
              (focus)="inputFocused = true"
              (keydown.enter)="onEnterPress($event)"
              (input)="autoGrowTextarea($event)"
              #commentInput
            ></textarea>

          </div>

          <div class="comment-input-actions" *ngIf="inputFocused || newComment">
            <div class="emoji-container">
              <!-- <button class="emoji-btn" title="Add emoji" (click)="toggleEmojiPicker()">😊</button> -->
              <img src="assets/reaction-emoji.svg" class="emoji-btn" title="Add emoji" (click)="toggleEmojiPicker()" />
              <div class="emoji-picker" *ngIf="showEmojiPicker">
                <emoji-mart
                  [showPreview]="false"
                  [isNative]="true"
                  [set]="'native'"
                  [showSingleCategory]="false"
                  [enableSearch]="false"
                  (emojiSelect)="addEmoji($event)"
                ></emoji-mart>
              </div>
            </div>
            <div class="action-buttons">
              <button class="btn-cancel" (click)="cancelComment()">Cancel</button>
              <button class="btn-submit" [disabled]="!newComment" (click)="userInfo && userInfo.access_token ? postComment(): requireLogin()">Comment</button>
            </div>
          </div>
          
        </div>
      </div>
    
      <!-- Comments List -->
      <div *ngIf="comments?.length > 0; else noComments">
        <div class="comment" *ngFor="let c of comments">
          <div class="roundIcon text-center mr-5" *ngIf="c._sender?.profileUrl; else userName">
            <img class="roundUserImage" src="{{c._sender?.profileUrl}}">
          </div>
          <ng-template #userName>
              <div class="roundIcon text-center mr-5"
                  [ngStyle]="{'background-color': c._sender?.userColor }">
                  <span class="text-uppercase notranslate">{{c._sender?.shortName}}</span>
              </div>
          </ng-template>
          <div class="comment-content">
            <div class="comment-header">
              <span class="comment-author">{{c._sender?.nickname }}</span>
              <span class="comment-time">{{ c.time | date: 'MMM d, y, h:mm a' }}</span>
            </div>
            <div class="comment-text">{{ c.message }}</div>
          </div>
        </div>
      </div>
    
      <ng-template #noComments>
        <p class="no-comments">No comments yet. Be the first to comment!</p>
      </ng-template>
    </div>
    
    
</div>